import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { News } from '../../../models/types';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-news-details-modal',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './news-details-modal.component.html',
  styleUrl: './news-details-modal.component.scss'
})
export class NewsDetailsModalComponent {
  @Input() news!: News;
  faFacebook = faFacebook;
  constructor(public activeModal: NgbActiveModal) {}

  closeModal(): void {
    this.activeModal.close();
  }
}
